import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';

export default {
  addItemsVariant: ActionButtonVariants.OUTLINE,
  addItemsTransparentBackground: true,
  singleBtnSize: ActionButtonSizes.SMALL,
  doubleBtnSize: ActionButtonSizes.SMALL,
  tipSelectorLabelColor: Styles.color.grey.one,
  totalsPadding: '1rem 0 0',
  tipSelectionBackground: Styles.color.primary,
};
